var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.hover ? 'link link--hover' : 'link',style:(_vm.style),attrs:{"href":_vm.href},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.href))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }